import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const policies = [{
  title: "1. Titolare del Trattamento",
  content: "Dolci Sapori di Tulone Alfonso\nVia Cappuccini 33/C — 92019 Sciacca (AG)\nP.IVA: 02118980842 — C.F.: TLNLNS63B24I533Y\nEmail: danielasabella099@gmail.com"
}, {
  title: "2. Tipologia di Dati Raccolti",
  content: "Raccogliamo esclusivamente le informazioni essenziali per offrirti un servizio d'eccellenza, come nome, indirizzo email e numero di telefono. Questi dati ci vengono forniti volontariamente quando richiedi informazioni sul nostro catalogo o effettui una prenotazione per le tue occasioni speciali."
}, {
  title: "3. Finalità del Trattamento",
  content: "I tuoi dati vengono utilizzati esclusivamente per gestire i tuoi ordini, rispondere alle tue richieste di personalizzazione e, solo previo tuo esplicito consenso, per inviarti aggiornamenti sulle nostre creazioni stagionali e sui segreti della nostra tradizione dolciaria."
}, {
  title: "4. Sicurezza e Riservatezza",
  content: "Il trattamento dei dati avviene attraverso sistemi informatici sicuri, adottando misure tecniche organizzative volte a prevenire perdite, usi illeciti o accessi non autorizzati. La tua fiducia è l'ingrediente più prezioso del nostro lavoro e la tuteliamo con il massimo rigore."
}, {
  title: "5. I Tuoi Diritti",
  content: "In conformità con il GDPR, hai il diritto di accedere ai tuoi dati, richiederne la rettifica, la portabilità o la cancellazione definitiva dai nostri archivi. Per esercitare questi diritti o per qualsiasi chiarimento, puoi contattarci direttamente attraverso i canali indicati nella sezione contatti."
}];
export default function PrivacyPolicy() {
  return <section data-section-id="227651" id="introduzione-alla-privacy" className="bg-background relative overflow-hidden py-20 md:py-32">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1566661/img/celestial_map_texture.png)] opacity-0 bg-cover bg-center pointer-events-none" />

      
    </section>;
}